module.exports = {
  API_ROOT: 'https://api.demo.2caf6c52.fina.global',
  PAY_KEY: 'pk_test_7eDxh1QLcQpFFUpSepTONJd800hGFerWpe',
  ACTIVE_TIME: 10800,  // 活躍時間 s
}
